import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { isRecommendationType } from '../../../ts/models/ContentType';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { IViewInfo } from '../../../ts/models/IViewInfo';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { EntityLinkProps } from './Elements/EntityLink';
import { MarkupField } from './Elements/MarkupField';
import { Name } from './Elements/Name';
import { Recommendation } from './Elements/Recommendation';
import { RelatedEntity } from './Elements/RelatedEntity';
import { Tags } from './Elements/Tags';
import { Tooltip } from './Elements/Tooltip';
import { UpdatedAt } from './Elements/UpdatedAt';
import { User } from './Elements/User';
import { ContentTooltipProps, TooltipDescriptionTestId } from './TooltipHelper';

export function ViewTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;

  // Views api does not return owner property at the top level, but rather adds to the workbook
  const workbook = (content as IViewInfo).workbook;
  const owner: IUserInfo = content.owner || workbook.owner;
  const workbookLink: EntityLinkProps = workbook ? {
    href: urls.exploreWorkbookUrl(workbook.id),
    iconImagePath: imgPath('workbook_content_type_small.svg'),
    iconHeightOverride: 18,  // the icon height is 18 just for workbooks :|
    name: workbook.name
  } : null;

  return (
    <Tooltip>
      <Name name={props.content.name} />
      <MarkupField markup={props.content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      {isRecommendationType(props.content.contentType) && <Recommendation explanationType={content.explanationType} users={content.similiarUsers} urls={urls}/>}
      <Tags tags={content.tags} />
      <RelatedEntity label={Messages.workbook()} link={workbookLink} />
      <User user={owner} label={Messages.owner()} urls={urls} />
      <UpdatedAt value={props.content.updatedAt} />
    </Tooltip>
  );
}
